<template>
  <tr>
    <td class="text-left">
      <label :for="option" v-html="opt.option.summary"/>
      <div v-html="opt.option.description"></div>
      <slot name="info" />
    </td>
    <td>&euro; {{opt.option.price || 0}}</td>
    <td>
      <input
        :name="opt"
        type="range"
        class="custom-range"
        v-model.number="$store.state.subscriberData[opt.option.dataField]"
        step="1"
        min="0"
        :max="opt.max"
      />
      <span>{{value}}</span>
    </td>
    <td>&euro; {{value * opt.option.price || 0}}</td>
  </tr>
</template>

<script>
export default {
  name: "Slider",
  props: ["option"],
  computed: {
    opt() {
      return this.$store.getters.getOption(this.$props.option);
    },
    value() {
      return this.$store.getters.getOptionData(this.$props.option);
    }
  },
};
</script>
